import { render, staticRenderFns } from "./IntegrateBP.html?vue&type=template&id=507ef54a&external"
import script from "./IntegrateBP.vue?vue&type=script&lang=js"
export * from "./IntegrateBP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports